import React, { useState, useEffect } from "react";
import Footer from "../../components/common/Footer";
import Navbar from "../../components/common/Navbar";
import useFetch from "../../hooks/useFetch";

import { LongDate } from "../../utils/LongDate";
import BulletinBanner from "../../components/user/BulletinBanner";

const UserBulletinPage = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const { data: fetchedData } = useFetch(`${API_URL}/bulletin/show`);

  // State for the reorderable data
  const [data, setData] = useState([]);

  // Update data state when fetchedData changes
  useEffect(() => {
    if (fetchedData) {
      setData(fetchedData);
    }
  }, [fetchedData]);

  // Carousel functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setData((prevData) => {
        if (prevData.length > 1) {
          const newData = [...prevData];
          const firstItem = newData.shift();
          newData.push(firstItem);
          return newData;
        }
        return prevData;
      });
    }, 30000); // 30 seconds
    return () => clearInterval(interval);
  }, []);

  const defaultImage =
    "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=";

  // Function to get image path with console log for debugging
  const getImagePath = (fileName) => {
    const path = fileName ? `/uploads/bulletin/${fileName}` : defaultImage;
    return path;
  };

  // Handle redirection to another page
  const handleRedirect = (bulletinId) => {
    const url = `/bulletin/${bulletinId}`;
    window.open(url, "_blank");
  };

  // Add loading state
  if (!data || data.length === 0) {
    return (
      <>
        <Navbar />
        <div className="mt-[60px] p-20">
          <p>Loading bulletins...</p>
        </div>
        <Footer />
      </>
    );
  }

  // Get file names for the main display
  const mainFileNames = data[0]?.file_name ? data[0].file_name.split(",") : [];
  return (
    <>
      <Navbar />
      <div className="mt-[60px]">
        <BulletinBanner />
        <div className="flex flex-col gap-5 w-full md:p-20 px-8 py-10">
          <div className="flex lg:flex-row flex-col gap-20 h-auto">
            {/* Main Display */}
            <div className="flex flex-col gap-5 w-full items-center">
              <div
                className="mx-auto cursor-pointer"
                onClick={() => handleRedirect(data[0]?.id)}
              >
                <img
                  className="rounded-[2rem] h-[380.82px] w-full object-cover"
                  src={getImagePath(mainFileNames[0])}
                  alt={data[0]?.header_name}
                />
                <div className="flex flex-col gap-2 w-full mt-3">
                  <p className="md:text-xl text-base">
                    {LongDate(data[0]?.event_date)}
                  </p>
                  <h1 className="font-bold md:text-[32px] text-[20px]">
                    {data[0]?.header_name}
                  </h1>
                  <p className="text-base md:text-xl line-clamp-4 text-justify">
                    {data[0]?.description}
                  </p>
                </div>
              </div>
            </div>

            {/* Sidebar Bulletins */}
            <div className="flex flex-col gap-9 w-full">
              {data.slice(1, 4).map((row, index) => (
                <div
                  key={index}
                  className="flex flex-col md:flex-row gap-5 md:gap-10 w-full cursor-pointer hover:bg-gray-100 p-2 rounded-lg transition-colors"
                  onClick={() => handleRedirect(row.id)}
                >
                  <div className="md:w-[286px] w-full">
                    <img
                      className="h-44 w-full rounded-lg object-cover"
                      src={getImagePath(row.file_name.split(",")[0])}
                      alt={row.header_name}
                    />
                  </div>
                  <div className="flex flex-col gap-2 w-full">
                    <h1 className="md:text-base text-xl font-bold">
                      {row.header_name}
                    </h1>
                    <p className="line-clamp-4 text-[13px] md:text-[17px]">
                      {row.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {data.length > 4 && (
            <>
              <hr className="h-px my-8 bg-gray-900 border-2" />

              <div className="flex flex-col gap-5 w-full">
                {data.slice(4).map((row, index) => (
                  <div
                    key={index}
                    className="flex flex-col md:flex-row gap-5 w-full cursor-pointer hover:bg-gray-100 p-2 rounded-lg transition-colors"
                    onClick={() => handleRedirect(row.id)}
                  >
                    <img
                      className="rounded-xl w-full h-full md:w-[213px] md:h-[152px] object-cover"
                      src={getImagePath(row.file_name.split(",")[0])}
                      alt={row.header_name}
                    />
                    <div className="flex flex-col gap-5 w-full">
                      <h1 className="font-bold text-[19px] md:text-[25px]">
                        {row.header_name}
                      </h1>
                      <p className="text-base md:text-xl line-clamp-3">
                        {row.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserBulletinPage;
